import { Card, CardContent, Typography, Grid, Avatar, Box, Divider, Paper, Chip, Tabs, Tab, IconButton } from "@mui/material";
  import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import { useEffect, useState } from "react";
import { modelServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import { useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Loader from "../../components/CustomLoader";
import { IMAGE_BASE } from "../../utils/constants";

const ViewModel = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [albumTabIndex, setAlbumTabIndex] = useState(0); // New state for album sub-tabs
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await modelServices.getAllDetails({ id });
        setData(response.data.data);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return <Loader />;
  if (!data) return <Typography variant="h6">No Data Found</Typography>;

  const { username, email, phoneNumber, dob, isOnline, modelCharctersticks } = data;

  return (
    <Box p={3} display="flex" gap={3}>
      {/* Left Section - Profile & Tabs */}
      <Paper elevation={3} sx={{ p: 3, borderRadius: 2, flex: 3 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ mb: 2 }}>
          <ArrowBackIcon />
        </IconButton>
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <Avatar src={IMAGE_BASE + modelCharctersticks.profilePhoto} sx={{ width: 120, height: 120, border: "3px solid #1976d2" }} />
          </Grid>
          <Grid item>
            <Typography variant="h4" fontWeight="bold">{username}</Typography>
            <Typography variant="body1" color="textSecondary">{email}</Typography>
            <Typography variant="body2">Phone: {phoneNumber}</Typography>
            <Typography variant="body2">DOB: {new Date(dob).toLocaleDateString()}</Typography>
            <Chip label={modelCharctersticks.streamStatus ? "Online" : "Offline"} color={modelCharctersticks.streamStatus ? "success" : "default"} />
            {/* { ? "Active" : "Inactive"} */}
          </Grid>
        </Grid>
        <Tabs value={tabIndex} onChange={(e, newValue) => setTabIndex(newValue)} sx={{ mt: 2 }}>
          <Tab label="Personal Data" />
          <Tab label="Model Details" />
          <Tab label="Documents" />
          <Tab label="Model Charcter Sticks" />
          <Tab label="Albums" />
        </Tabs>
        <Divider sx={{ my: 2 }} />
        {/* Tabs Content */}
        {tabIndex === 0 && (
          <TableContainer component={Paper} sx={{ maxWidth: "650px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={3}><b>Personal Data</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow><TableCell><b>Age</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.age || "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>Country</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.country || "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>Category Type</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.categoryType || "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>About Me</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.aboutMe || "-"}</TableCell></TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {tabIndex === 1 && (

          <TableContainer component={Paper} sx={{ maxWidth: "650px" }}>
            <Table>
              <TableHead>
                <TableRow><TableCell colSpan={3}><b>Model Details</b></TableCell></TableRow>
              </TableHead>
              <TableBody>
                <TableRow><TableCell><b>Country</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.country || "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>Paid Member</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.isPaid ? "Yes" : "No"}</TableCell></TableRow>
                <TableRow><TableCell><b>Spying Price</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.spyingPrice ? `$${modelCharctersticks.spyingPrice}` : "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>Private Price</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.privatePrice ? `$${modelCharctersticks.privatePrice}` : "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>Streaming Status</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.streamStatus ? "Active" : "Inactive"}</TableCell></TableRow>
                <TableRow><TableCell><b>Exclusive Private Price </b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.exclusivePrivatePrice || "-"}</TableCell></TableRow>

                <TableRow><TableCell><b>Group Show Price</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.groupShowPrice || "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>Ticket Show Price</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.ticketShowPrice || "-"}</TableCell></TableRow>

                <TableRow><TableCell><b>Languages</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks?.languages?.join(" ,") || "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>Interests</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks?.interest?.join(" ,") || "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>Subculture</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks?.subculture?.join(" ,") || "-"}</TableCell></TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {tabIndex === 2 && (
          <Box>
            <Typography><b>Document Type:</b> {modelCharctersticks.documentType}</Typography>
            <Grid item xs={12} className="DocumentField">
              <img src={IMAGE_BASE + modelCharctersticks.idFrontImage} alt="ID Front" width={150} style={{ marginRight: 10 }} />
              <img src={IMAGE_BASE + modelCharctersticks.idBackImage} alt="ID Back" width={150} style={{ marginRight: 10 }} />
            </Grid>
            <br />
            <Typography><b>Selfie With Id</b></Typography>
            <Grid item xs={12} className="DocumentField">
              <img src={IMAGE_BASE + modelCharctersticks.selfieWithId} alt="Selfie with ID" width={150} />
            </Grid>
          </Box>
        )}
        {tabIndex === 3 && (
          <TableContainer component={Paper} sx={{ maxWidth: "650px" }}>
            <Table>
              <TableHead>
                <TableRow><TableCell colSpan={3}><b>Model Character Sticks</b></TableCell></TableRow>
              </TableHead>
              <TableBody>
                <TableRow><TableCell><b>Hair Color</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.hair || "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>Eye Color</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.eyeColor || "-"}</TableCell></TableRow>
                <TableRow><TableCell><b>Body Type</b></TableCell><TableCell>:</TableCell><TableCell>{modelCharctersticks.bodyTypes || "-"}</TableCell></TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {tabIndex === 4 && (
          <>
            {modelCharctersticks.albums && modelCharctersticks.albums.length > 0 ? (
              <>
                <Tabs value={albumTabIndex} onChange={(e, newValue) => setAlbumTabIndex(newValue)} sx={{ mt: 2 }} className="customTabClass">
                  {modelCharctersticks.albums.map((album, index) => (
                    <Tab key={album._id} label={`${album.albumName} Albums`} />
                  ))}
                </Tabs>
                <Divider sx={{ my: 2 }} />

                <Box sx={{ mt: 2 }}>
                  {modelCharctersticks.albums.map((album, index) =>
                    albumTabIndex === index ? (
                      <Box key={album._id} sx={{ border: "1px solid #ccc", p: 2, borderRadius: 2 }}>
                        <Grid container spacing={2}>
                          {album.images && album.images.length > 0 ? (
                            album.images.map((img) => (
                              <Grid item key={img._id}>
                                <img
                                  src={IMAGE_BASE + img.src}
                                  alt={album.albumName}
                                  width={100}
                                  height={100}
                                  style={{ borderRadius: 8, objectFit: "cover", border: "1px solid #ddd" }}
                                />
                              </Grid>
                            ))
                          ) : (
                            <Typography>No Images Available</Typography>
                          )}
                        </Grid>
                      </Box>
                    ) : null
                  )}
                </Box>
              </>
            ) : (
              <Typography>No Albums Available</Typography>
            )}
          </>
        )}
      </Paper>
      {/* Right Section - Achievements */}
      {/* <Paper elevation={3} sx={{ p: 3, borderRadius: 2, flex: 1 }}>
                <Typography variant="h6" fontWeight="bold">Achievements</Typography>
                <Chip label="Explorer" color="primary" sx={{ my: 1 }} />
                <Chip label="Mentor" color="success" sx={{ my: 1 }} />
                <Chip label="Expert" color="warning" sx={{ my: 1 }} />
            </Paper> */}
    </Box>
  );
};

export default ViewModel;